<template>
  <div class="life1">
    <div>
      龍崎區地質特殊，泥岩遍佈龍船、牛埔、石嘈地區，在長年沖刷侵蝕下而後形成自然人文景觀，牛埔農塘，因此成了龍崎有名的景點，牛埔農塘另設置牛埔泥岩教學園區，分別設了六個解說教育點，訂為「飲水思源」、「綻放綠洲」、「古色古香」、「生生不息」、「水中樓台」、「湖光山色」等主題。
    </div>
    <div>&nbsp;</div>
    <div>
      龍崎附近也有許多風景優美的休閒地區，如龍船里龍船窩最高峰365高地，可遠望草山月世界，遼闊的視野讓人可以放寬身心。位於臺南市與高雄市交界的龍船窩登山步道遊憩區，更是早晨看日出、下午看日落、晚上觀星辰夜景的好地方。
    </div>
    <div>&nbsp;</div>
    <div>
      大坑農場位於本區土崎里烏樹林與新化區大坑里交界，可遠眺中央山脈、大岡山群山環抱，是個欣賞日出、雲海都很不錯的地點，農場內有多項休閒設施，也有許多美味的山野小吃，為休閒渡假的去處。
    </div>
    <div>&nbsp;</div>
    <div>
      最推薦的景觀名勝莫過於虎形山；在地理位置上依山傍谷，同時形如猛虎雄踞，「虎形山」遂因此得名，虎形山吊橋亦為一大勝景，不但能同時欣賞到綠林、深谷的自然美景，也是龍崎首座風景區及休閒公園地點。虎形山目前規劃為兼具景觀及休閒功能的森林公園，規劃有烤肉區、蓮花池、原有的虎形山吊橋與紅色小吊橋，再搭配停車場及步道、涼亭的規劃，虎形山勢為南市重要休閒渡假中心，此外一八二縣道富民橋下已規劃為龍崎休閒廣場-親水公園，規劃有烤肉區、噴水池（水舞）、涼亭、兒童遊樂區，經過綠美化後--花木扶疏、綠意盎然，亦為崎頂里值得一遊的景點。
    </div>
    <div>&nbsp;</div>
    <div>&nbsp;</div>
    <div>
      <img src="~@/assets/images/life-page1-img-1.jpg" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'life1',
  data() {
    return {
      page: this.$route.query.page,
    };
  },
  watch: {
    $route() {
      this.page = this.$route.query.page;
    },
  },
};
</script>

<style scoped>
.life1 img {
  width: 100%;
}
</style>
